import PropTypes from 'prop-types'

import { SOCIAL_MEDIA_URLS } from 'resources/urls'

import { InstagramIcon, FacebookIcon, LinkedInIcon, TwitterIcon, SocialLinkButton, SocialContainer } from './styles'

const SocialLinks = ({ className = '', isFullWidth = false }) => (
  <SocialContainer className={`${isFullWidth ? 'full-width' : ''} ${className}`}>
    <SocialLinkButton href={SOCIAL_MEDIA_URLS.TWITTER} target="_blank" rel="noopener noreferrer">
      <TwitterIcon alt="Twitter" />
    </SocialLinkButton>
    <SocialLinkButton href={SOCIAL_MEDIA_URLS.FACEBOOK} target="_blank" rel="noopener noreferrer">
      <FacebookIcon alt="Facebook" />
    </SocialLinkButton>
    <SocialLinkButton href={SOCIAL_MEDIA_URLS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
      <InstagramIcon alt="Instagram" />
    </SocialLinkButton>
    <SocialLinkButton href={SOCIAL_MEDIA_URLS.LINKED_IN} target="_blank" rel="noopener noreferrer">
      <LinkedInIcon alt="LinkedIn" />
    </SocialLinkButton>
  </SocialContainer>
)

SocialLinks.propTypes = {
  className: PropTypes.string,
  isFullWidth: PropTypes.bool,
}

export default SocialLinks
